module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module id = ./node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module chunks = 0